/**
 * Event name emitted when dropdown value changes
 */
export const NEW_TO_BRAND_EVENT = 'newToBrandEvent';
export const NEW_TO_BRAND_GROUPBY_EVENT = 'newToBrandGroupByEvent';
